import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";

// Configure the PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

type DocumentLoadSuccessParams = {
  numPages: number;
};

type PdfViewerProps = {
  src: string;
};

const PdfViewer: React.FC<PdfViewerProps> = ({ src }) => {
  const [numPages, setNumPages] = useState<number>(0);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [zoom, setZoom] = useState<number>(0.4); // default 40%

  // Exact zoom levels to prevent float errors
  const zoomSteps = [0.4, 0.6, 0.8, 1];

  const zoomIn = () => {
    const currentIndex = zoomSteps.indexOf(zoom);
    if (currentIndex < zoomSteps.length - 1) {
      setZoom(zoomSteps[currentIndex + 1]);
    }
  };

  const zoomOut = () => {
    const currentIndex = zoomSteps.indexOf(zoom);
    if (currentIndex > 0) {
      setZoom(zoomSteps[currentIndex - 1]);
    }
  };

  const onDocumentLoadSuccess = ({ numPages }: DocumentLoadSuccessParams) => {
    setNumPages(numPages);
    setPageNumber(1);
  };

  return (
    < div >
      {/* Top controls */}
      <div
        style={ numPages > 1 ?{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          alignItems: "center",
          width: "100%",
          maxWidth: "320px",
          margin: "0 auto 10px",
        }:{}}
      >
        {/* Pagination */}
        {numPages > 1 && (
          <div style={{ display: "flex", alignItems: "center" }}>
            <button
              className="pdf-button"
              onClick={() => setPageNumber((prev) => Math.max(prev - 1, 1))}
              disabled={pageNumber <= 1}
            >
              <i className="ic-keyboard_arrow_left"></i>
            </button>

            <span style={{ margin: "0 10px", whiteSpace: "nowrap" }}>
              Page {pageNumber} of {numPages}
            </span>

            <button
              className="pdf-button"
              onClick={() =>
                setPageNumber((prev) => Math.min(prev + 1, numPages))
              }
              disabled={pageNumber >= numPages}
            >
              <i className="ic-keyboard_arrow_right"></i>
            </button>
          </div>
        )}

        {/* Zoom Controls */}
        <div style={ numPages > 1 ?{}:{marginBottom: "10px"}}>
          <button
            className="pdf-button"
            onClick={zoomOut}
            disabled={zoom === 0.4}
          >
            -
          </button>
          <span style={{ margin: "0 25px" }}>{Math.round(zoom * 100)}%</span>
          <button
            className="pdf-button"
            onClick={zoomIn}
            disabled={zoom === 1}
          >
            +
          </button>
        </div>
      </div>

      {/* PDF Content */}
      <Document
        file={src}
        onLoadSuccess={onDocumentLoadSuccess}
        loading={<div>Loading PDF...</div>}
      >
        <Page pageNumber={pageNumber} scale={zoom}  className="cursor-pointer" renderTextLayer={false} onClick={() => window.open(src, "_blank", "noopener,noreferrer")}/>
      </Document>
    </div>
  );
};

export default PdfViewer;
